import React from "react";
import comingsoon from "../../src/assets/soon.jpg";
import { Bell } from "lucide-react";

export default function ComingSoon() {
  return (
    <div className="relative min-h-screen w-full flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      {/* <div className="absolute inset-0 w-full h-full">
        <img
          src={comingsoon}
          alt="coming soon background"
          className="w-full h-full object-cover"
          loading="lazy"
          sizes="100vw"
        />
      </div> */}

      {/* Overlay for contrast */}
      <div className="
 absolute inset-0 
  bg-gradient-to-r from-[#1a1a1a]/70 via-[#a07f33]/40 to-[#1a1a1a]/70
  bg-[length:200%_200%]
  animate-gradientFlow flex items-center justify-center


">



        {/* Content */}
        <div className="relative z-10 flex flex-col items-center justify-center text-center px-4 sm:px-6 md:px-10 lg:px-12 py-6 sm:py-8 ">
          <Bell className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 text-black mb-4 animate-bounce" />

          <h1 className="text-black text-3xl sm:text-4xl md:text-5xl font-semibold drop-shadow-lg">
            Coming Soon
          </h1>

          <p className="text-black text-base sm:text-lg md:text-xl mt-3 max-w-md drop-shadow-md">
            We’re working on something amazing. Stay tuned!
          </p>
        </div>
      </div>
    </div>
  );
}
